import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { currentUserSelector } from "../../redux/reducers/userSlice";
import { useAppSelector } from "../../redux/store";
import BadgePersonal from "../badge/badge-personal";
import HomeSurveyAnswerListPage from "./answer-list.page";
import HomeAppointmentListPage from "./appointment-list.page";
import HomeUserListPage from "./user-list.page";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function HomePage() {
  const currentUser = useAppSelector(currentUserSelector);
  const navigate = useNavigate();
  const isAdministrator = currentUser?.authorityChecks.isAdministrator;
  const isSportellista = currentUser?.authorityChecks.isSportellista;
  const isProfessionista = currentUser?.authorityChecks.isProfessionista;
  const isOperatore = currentUser?.authorityChecks.isOperatore;
  const [modalOpen, setModalOpen] = useState(false);
  const isUser = currentUser?.authorityChecks.isUser;
  const toggleModal = () => setModalOpen(!modalOpen);

  return (
    <div>
      <div className={currentUser ? "" : "row justify-content-center"}>
        <div className={currentUser ? "" : "col-md-3 mb-3"}>
          <div className="card p-3 h-100">
            <div style={{ textAlign: "center" }}>
              <Button
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  whiteSpace: "normal",
                  fontSize: "2rem",
                }}
                color="primary"
                // onClick={() => navigate("/survey-fasce-bari")}
                onClick={toggleModal}
              >
                Questionario Fascia di Locazione
              </Button>
            </div>
          </div>
        </div>
        <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>Vuoi calcolare il canone secondo:</ModalHeader>
          <ModalBody>
            <div style={{ display: "flex", gap: "20px", justifyContent: "center", marginTop: "1rem" }}>
              {/* Prima opzione */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                <Button
                  color="primary"
                  style={{ width: "100%", height: "100px", fontSize: "1.2rem" }}
                  onClick={() => navigate("/survey-fasce-bari/13-03-2024")}
                >
                  Accordo Territoriale siglato il <br />
                  13/03/2024
                </Button>
                <span style={{ marginTop: "0.5rem", fontWeight: "bold" }}>
                  {" "}
                  <a
                    href="https://www.comune.bari.it/documents/114837/53185702/Accordo+territoriale+APPC+-+ASPPI+-+CONFABITARE+-+ASSEDIL+-+UPPI+e+SUNIA+-+SICET+-+UNIAT+-+ASSOCASA+-+SAI+-+CISAL.pdf/5df3dd86-3c79-4085-ab41-31912302431a"
                    target="_blank"
                    className="text-blue-600 font-semibold hover:underline"
                    rel="noreferrer"
                  >
                    Accordo Territoriale 13/03/2024
                  </a>
                </span>
              </div>

              {/* Seconda opzione */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                <Button
                  color="primary"
                  style={{ width: "100%", height: "100px", fontSize: "1.2rem" }}
                  onClick={() => navigate("/survey-fasce-bari/13-09-2024")}
                >
                  Accordo Territoriale siglato il <br />
                  13/09/2024
                </Button>
                <span style={{ marginTop: "0.5rem", fontWeight: "bold" }}>
                  <a
                    href="https://www.comune.bari.it/documents/114837/53185702/09-09-2024+Accordo+territoriale+FEDERPROPRIETA+-+UNIONCASA+-+FEDER+CASA+-+FENIT+CONFIAL+-+ANIA.pdf/42cc4462-c360-4ab2-a615-b37e001ac024"
                    target="_blank"
                    className="text-blue-600 font-semibold hover:underline"
                    rel="noreferrer"
                  >
                    Accordo Territoriale 13/09/2024
                  </a>
                </span>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {!currentUser && (
          <div className="col-md-3 mb-3">
            <div className="card p-3 h-100 d-flex">
              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Button
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    whiteSpace: "normal",
                    fontSize: "2rem",
                  }}
                  color="primary"
                  onClick={() => navigate("/user/login")}
                >
                  Agenzia sociale casa
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        <div>
          {isProfessionista || isSportellista ? <BadgePersonal home /> : ""}
          {currentUser ? (
            isProfessionista ? (
              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: "2rem" }}>
                <div className="card">
                  <div className="container-fluid">
                    <HomeAppointmentListPage fixedUser={currentUser.id} />
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: "2rem" }}>
                <div className="card">
                  <div className="container-fluid">
                    <HomeAppointmentListPage />
                  </div>
                </div>
              </div>
            )
          ) : (
            ""
          )}
          {isAdministrator || isSportellista || isOperatore ? <HomeUserListPage withLink /> : ""}
          {isAdministrator || isSportellista || isOperatore || isUser ? <HomeSurveyAnswerListPage withLink /> : ""}
        </div>
      </div>
    </div>
  );
}
